<template>
  <div>
    <sign-up :project-id="projectId" :class-id="classId" :project-name="projectName" v-bind:is-sign-up.sync="isSignUp" />
    <sign-up-zz :project-id="projectId" :class-id="classId" v-bind:is-sign-up-zz.sync="isSignUpZz" />
    <Top />
    <div class="maindiv pproject-wrap  bg-gray">
      <Banner />
      <div class="mt160 bgw htmldiv">
        <banner-title :trainType="trainType" />
        <div class="tbdiv fs16 lh10 pb5 dflex fs24 align-items-center tcenter">
          <span class="cpointer dinline-block" @click="getData(1,1)" :class="{active:trainType==1}">社会培训</span>
          <span class="cpointer dinline-block" @click="getData(1,5)" :class="{active:trainType==5}">特种作业操作工培训与考证</span>
          <span class="cpointer dinline-block" @click="getData(1,4)" :class="{active:trainType==4}">中职教师培训</span>
          <span class="cpointer dinline-block" @click="getData(1,3)" :class="{active:trainType==3}">技能等级培训与认定</span>
        </div>
        <div class="cont bgw">
          <item-new v-for="(item,index) in news" :key="item['id']" :item="item" :trainType="trainType" @sign="sign" />
        </div>
        <div class="page tcenter">
          <Pagec v-if="total>0" :pagen="page" :size="size" :total="total" :pageClass="'page-blue'"
            @get-data="getData" />
        </div>
      </div>
      <div class="ht30"></div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../top'
import Banner from '../banner'
import Bottom from '../bottom'
import TrainItem from '../../index/train-item'
import BannerTitle from './ttitle'
import Pagec from '../../index/page'
import SignUp from './signUp'
import SignUpZz from './signUpZz'
import ItemJn from './itemJn'
import QRCode from 'qrcodejs2'
import liebaoBrowser from '../../../assets/js/lrtk'
import ItemNew from '../project/ItemNew'
export default {
  name: 'index',
  components: {
    Top,
    Banner,
    Bottom,
    TrainItem,
    BannerTitle,
    Pagec,
    SignUp,
    SignUpZz,
    ItemJn,
    ItemNew
  },

  data () {
    return {
      'spe_type': {
        1: '高压电工初训',
        2: '高压电工复训'
      },
      'news': [],
      'page': 1,
      'size': 9,
      'total': 0,
      'trainType': 1,
      'isSignUp': false,
      'isSignUpZz': false,
      'projectId': 0,
      'projectName': '',
      'classId': 0
    }
  },

  created () {
    let {
      trainType
    } = this.$route.query
    this.trainType = trainType || 1
    this.getData(1, this.trainType)
  },

  updated () {
    this.$nextTick(() => {
      for (var ind in this.news) {
        this.creatQrCode('qrcode-div' + this.news[ind]['id'], this.news[ind]['id'])
      }
    })
  },

  methods: {
    creatQrCode (qrCodeUrl, id) {
      var docd = document.getElementById(qrCodeUrl)
      var that = this
      if (docd) {
        docd.innerHTML = ''
        var qrcode = new QRCode(docd, {
          text: 'http://' + document.domain + that.$router.options.base + 'train/project/sign-up-tz?id=' +
              id, // 需要转换为二维码的内容
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }
    },
    getData (page, type) {
      this.trainType = type == undefined ? this.trainType : type
      this.page = page
      var getParam = {}
      getParam['type'] = this.trainType
      getParam['page'] = this.page - 1
      getParam['size'] = this.size
      let url = 'training-skill/list'
      // if (this.trainType == 5) {
      //   url = 'training-skill/get-special-worker-train-list'
      // }
      this.$request.get(url, getParam, response => {
        if (response.status == 200) {
          if (this.trainType == 5) { this.news = response.data.data.noticeList } else { this.news = response.data.data.noticeList }
          this.total = response.data.data.count
        }
      }, error => {
        console.log(error)
      })
    },
    signUpItem (obj) { //社会
      this.projectName =  obj.name
      this.projectId = obj.project_id
      this.classId = obj.class_id
      this.isSignUp = true
    },
    signUpItemZz (obj) { //中职
      this.projectId = obj.project_id
      this.classId = obj.class_id
      this.isSignUpZz = true
      // console.log('父组件signUpItemZz：' + this.isSignUpZz)
    },
    sign (item) { //社会和中职
      let {id, name,trainProject} = item
      let type_id = trainProject.type_id
      let project_id = trainProject.id
      let obj = {
        project_id,
        class_id: id,
        name
      }
      // console.log(obj)
      //console.log(obj)
      if (type_id == 4){ // 中职培训
        this.signUpItemZz(obj) 
      } else if (type_id == 1) {// 社会培训
         this.signUpItem(obj) 
      }
    }
  }
}
</script>

<style scoped>
  .pproject-wrap .ptlist {
    padding: 80px 0 80px 55px;
  }

  .pproject-wrap .ptlist .project {
    margin: 0 15px 35px 0;
  }

  .tbdiv {
    margin: 50px 50px 26px;
    flex-wrap: nowrap;
    background: #f6f6f6;
    height: 60px;
  }

  .tbdiv span {
    flex: auto;
    padding: 0 20px;
    line-height: 60px;
    background: #f6f6f6;
  }

  .tbdiv span.active {
    background: #1492ff;
    border-radius: 5px;
    color: #fff;
  }

  .est {
    border-bottom: 1px solid #ddd;
  }

  .est .tt {
    margin-bottom: -1px;
  }

  .est .blue {
    border-bottom: 1px solid #1787e0;
  }

  .cddiv {
    width: 400px;
  }

  .cont .pt {
    height: 60px;
    line-height: 60px;
  }

  .cont .pt::before {
    top: 28px;
  }

  .cont .pt .stt {
    height: 60px;
  }

  .cont {
    padding: 20px 75px;
  }

  .tz {
    font-size: 22px;
    margin-top: 15px;
    margin-left: 175px;
    overflow: hidden;
    height: 100px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .tz span {
    color: rgb(102, 104, 103);
  }

  .tz span::before {
    content: url(../../../assets/images/tran.png);
    position: relative;
    top: 4px;
  }

  .tz-button {
    display: inline-block;
    text-align: center;
    margin-top: 10px;
    margin-left: 175px;
    width: 88px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    background: #147ad8;
    border: none;
    border-radius: 15px;
    color: #fff;
  }

  .qrcode-div {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100px;
    height: 100px;
    background: red;
  }

</style>


// WEBPACK FOOTER //
// src/components/train/project/index.vue